<template>
	<div style="margin-bottom: 50px;box-sizing: border-box;">
		<div class="body">
			<div style="background:#E5EDFB;">
				<div style="width: 120px; height: 40px;background: #0052D9;
			border-radius: 0px 20px 20px 0px;color: white;font-size: 20px;font-weight: bold;
			line-height: 40px;text-align: center;">
					课题定位
				</div>
			</div>
			<div class="mktitle">
				<div :class="activeCard==1?'activeCard':''" @click="activeCard = 1">根据内容定位</div>
				<div :class="activeCard==2?'activeCard':''" @click="activeCard = 2">通过提问定位</div>
				<div :class="activeCard==3 || activeCard == 4?'activeCard':''" @click="activeCard = 3">邀请专家定位</div>
			</div>
			<div class="card-one" v-if="activeCard == 1">
				<div class="miaosu">
					问题描述：
				</div>
				<div class="content">
					<div>
						<div class="item-content">
							<div class="muban" @click="$router.push(`/kongEditor?index=${0}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从空白模板创建</p>
								</div>
							</div>
							<div class="muban" v-if='$store.state.releaseInfo[0].id'
								@click="$router.push(`/histroyEditor?index=${0}`)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>从上次修改创建</p>
								</div>
							</div>
							<div class="muban" v-for="(item,index) in zyTemplate" :key="item.id"
								@click="toMbDetail(item.id,0)">
								<div>
									<img src='../../assets/images/muban.png' alt="">
									<p>{{item.name}}</p>
								</div>
							</div>

						</div>
						
					</div>
					
					<div style="margin: 15px 0;">
						<el-upload :on-success='uploadWZB1' class="upload-demo"
							:headers='{token:$store.state.userInfo.token}' accept='.pdf,.word,.docx,.txt,.xlsx'
							:action="uploadPath+'common/upload'" multiple :file-list="fileList1" :limit='3'>
							<el-button size="small" type="primary">上传文件</el-button>
						</el-upload>
					</div>
					<!-- <div class="miaosu">
						问题描述显示：
					</div> -->
					<div @click="$router.push(`/editorbanben1?index=${form1.content}`)" class="content" v-html="renderedMarkdown1"></div>
					<div  v-if="form1.content" class="bottom" style="margin-top: 0px;">
						<span
						  style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
						  @click="$router.push(`/editorbanben1?index=${form1.content}`)"
						>
						  查看
						</span>
					      <span v-if="form1.content"
					        style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
					        @click="$router.push(`/editorbanben?index=${form1.content}`)"
					      >
					        编辑
					      </span>
					      
					      <span 
						    v-if="form1.content"
					        class="delitem" 
					        style="display:inline-block;margin-left: 30px;color: red;margin-top: 0px;" 
					        @click="deleteDrafts(1,form1.content,'a1')"
					      >
					        删除
					      </span>
					</div>
				</div>
				
			</div>
			<div class="card-two" v-if="activeCard == 2">
				<h3>问卷调查</h3>
				<div v-for="(item,index) in wenJuan" class="wenJuan">
					<p>{{item.wen}}</p>
					<el-radio-group v-model="radio">
						<div style="margin: 15px 0;" v-for="(ansewr,index) in item.ansewr"><el-radio
								:label="ansewr.value">
								{{ansewr.name}}
							</el-radio></div>
					</el-radio-group>
				</div>
			</div>
			<div class="card-three" v-if="activeCard == 3">
				<div class="head-muban">
					<div class="miaosu">
						问题描述：
					</div>
					<div class="content">
						<div>
							<div class="item-content">
								<div class="muban" @click="$router.push(`/kongEditor?index=${1}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从空白模板创建</p>
									</div>
								</div>
								<div class="muban" v-if='$store.state.releaseInfo[1].id'
									@click="$router.push(`/histroyEditor?index=${1}`)">
									<div>
										<img src='../../assets/images/muban.png' alt="">
										<p>从上次修改创建</p>
									</div>
								</div>
								<div class="muban" v-for="(item,index) in zyTemplate" :key="item.id"
									@click="toMbDetail(item.id,1)">
									<div class="m1">
										<img src='../../assets/images/muban.png' alt="">
										<p class="m2">{{item.name}}</p>
									</div>
								</div>
								
							</div>
							<div style="margin: 15px 0;">
								<el-upload :on-success='uploadWZB3' class="upload-demo"
									:headers='{token:$store.state.userInfo.token}' accept='.pdf' :disabled='JSradio !== 3'
									:action="uploadPath+'common/upload'" multiple :file-list="fileList3" :limit='3'>
									<el-button size="small" type="primary">点击上传</el-button>
								</el-upload>
							</div>
						</div>
						<div class="head-muban">
							<div style="display: flex;align-items: center;">
								<!-- <div class="jtitle">
									<span style="color: red;"></span> 问题描述显示：
								</div> -->
								<div @click="$router.push(`/editorbanben1?index=${form2.content}`)" class="rich-text-content" v-html="renderedMarkdown2"></div>
							</div>
							<div  v-if="form2.content" class="bottom" style="margin-top: 0px;">
								<span 
								  style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
								  @click="$router.push(`/editorbanben1?index=${form2.content}`)"
								>
								  查看
								</span>
							      <span v-if="form2.content"
							        style="display:inline-block;margin-left: 30px; color: #0052D9;margin-top: 0px;" 
							        @click="$router.push(`/editorbanben?index=${form2.content}`)"
							      >
							        编辑
							      </span>
							      
							      <span 
								    v-if="form2.content"
							        class="delitem" 
							        style="display:inline-block;margin-left: 30px;color: red;margin-top: 0px;" 
							        @click="deleteDrafts(1,form2.content,'a2')"
							      >
							        删除
							      </span>
							</div>
						</div>
					</div>
				</div>
				
				<div class="jieshao">
					<div class="miaosu">
						个人介绍：
					</div>
					<div class="content">
						<div class="wenJuan">
							<el-radio-group v-model="form2.people_msg_type" @input='clog'>
								<div style="margin: 25px 0;"><el-radio :label="1">使用系统中的个人信息</el-radio></div>
								<div style="margin: 25px 0;"><el-radio :label="2">使用学术/单位个人主页</el-radio><input
										:disabled='form2.people_msg_type !== 2' type="text" v-model="form2.home_page"
										style="width: 300px;height: 30px;border: 1px solid #D2D2D2;"></div>
								<div style="margin: 25px 0;display: flex;align-items: center;"><el-radio
										:label="3">上传个人简历</el-radio>
									<div style="margin: 15px 0;">
										<el-upload :on-success='uploadWZB2' class="upload-demo"
											:headers='{token:$store.state.userInfo.token}' accept='.pdf' :disabled='form2.people_msg_type !== 3'
											:action="uploadPath+'common/upload'" multiple :file-list="fileList2" :limit='3'>
											<el-button size="small" type="primary">点击上传</el-button>
										</el-upload>
									</div>
								</div>
								<div style="margin: 25px 0;"><el-radio :label="4">直接介绍自己</el-radio>
								<input	:disabled='form2.people_msg_type !== 4' type="text" v-model="form2.people_msg" style="width: 300px;height: 30px;border: 1px solid #D2D2D2;">
								</div>
							</el-radio-group>
						</div>
					</div>
				</div>
				<div class="jieshao">
					<div class="miaosu">
						专家要求：
					</div>
					<div class="content">
						<div class="wenJuan">
							<el-radio-group v-model="form2.specialist_type" @input='clog'>
								<div style="margin: 25px 0;"><el-radio :label="1">高级专家(副高职称/8年以上行业经验)</el-radio></div>
								<div style="margin: 25px 0;"><el-radio :label="2">资深专家(高级职称/15年以上行业经验)</el-radio></div>
								<div style="margin: 25px 0;display: flex;align-items: center;"><el-radio
										:label="3">权威专家(三级教授及以上包含院士/杰青)</el-radio></div>

							</el-radio-group>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="card-four">
				<div class="AIdingwei">
					<h3>智能定位结果</h3>
					<div class="AIbody">
						<p>根据您的信息，您的问题有以下特征：</p>
						<div class="Aianswer">
							<p>这是一个涉及流体和估计的流固耦合问题，属于力学和机械等学科。可以借助ALE方法开展相关模拟。……。相关的案例如下。本网站有与
								之相关资源(查看资源)
								</p>
						</div>
						<p style="font-size: 14px;">定位不准确？<span style="color: red;cursor: pointer;">邀请专家定位</span></p>
					</div>
				</div>
				<div class="AIdingwei">
					<h3>专家定位结果</h3>
					<div class="AIbody">
						<div class="Aianswer">
							<p>提交成功，xxx学术委员会尽快为您推荐合适的专家。
个人页面系统客服处可查看进展。
								</p>
						</div>
					</div>
				</div>
			</div> -->
			<div class="submit" @click="verifyForm1" v-if="activeCard == 1">
				提交
			</div>
			<div class="submit" v-if="activeCard == 2">
				提交
			</div>
			<div class="submit" @click="verifyForm3" v-if="activeCard == 3">
				提交
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeCard: 1,
				radio: '',
				wenJuan: [{
						wen: '您的餐厅主要经营',
						ansewr: [{
								value: 1,
								name: '中餐'
							},
							{
								value: 2,
								name: '西餐'
							},
							{
								value: 3,
								name: '快餐'
							},
							{
								value: 4,
								name: '减肥餐'
							},
							{
								value: 5,
								name: '其他'
							}
						]
					}, {
						wen: '您的餐厅主要经营',
						ansewr: [{
								value: 1,
								name: '中餐'
							},
							{
								value: 2,
								name: '西餐'
							},
							{
								value: 3,
								name: '快餐'
							},
							{
								value: 4,
								name: '减肥餐'
							}
						]
					},
					{
						wen: '您的餐厅主要经营',
						ansewr: [{
								value: 1,
								name: '中餐'
							},
							{
								value: 2,
								name: '西餐'
							},
							{
								value: 3,
								name: '快餐'
							},
							{
								value: 4,
								name: '减肥餐'
							}
						]
					}
				],
				JSradio: '',
				fileList: [],
				zyTemplate: [],
				fileList1:[],
				fileList2:[],
				fileList3:[],
				form1:{
					content:'',
					files:''
				},
				formFiles1:[],
				formFiles2:[],
				formFiles3:[],
				form2:{
					content:'',
					files:'',
					people_msg_type:'',//:1=使用系统中的个人信息,2=使用学术/单位个人主页,3=上传个人简历,4=直接接受自己
					home_page:'',
					file:'',
					specialist_type:'', //	专家要求:1=高级专家,2=资深专家,3=权威专家
					people_msg:''
				},
				formActionObj:{
					form1:{
						commit:async (option)=>{
							return await this.$api.topicPosition({...option})
						},
					},
					form2:{
						commit:async (option)=>{
							return await this.$api.DZtopicPosition({...option})
						},
					},
				},
				renderedMarkdown1:'',
				renderedMarkdown2:'',
			}
		},
		watch: {
			'$store.state.releaseInfo': {
				handler(n, o) {
					this.form1.content = this.$store.state.releaseInfo[0].id
					this.form2.content = this.$store.state.releaseInfo[1].id
					this.fetchMarkdownInfo(this.form1.content, 'renderedMarkdown1');
					this.fetchMarkdownInfo(this.form2.content, 'renderedMarkdown2');  
				},
				deep: true,
				immediate: true
			},
		
		},
		
		created() {
			this.getTemplateLists()
			const release = [{
					id: '',
					first_id: '',
				},
				{
					id: '',
					first_id: '',
				},
			]
			this.$store.commit('init_releaseInfo', release)
		},
		methods: {
			async deleteDrafts(type,id,a){
				
				let info 
				if(type == 1){
					info = await this.$api.getDraftProjectneedDel1({projectneed_id:id})
					// if(info.code == 1) this.Projectneed.data = this.Projectneed.data.filter(obj => obj.id !== id);
				}
				
				if(info.code == 1){
					this.$message({
						message:info.msg,
						 type: 'success'
					})
					if(a=='a1'){
						this.renderedMarkdown1 = '';
						this.form1.content = '';
					}
					if(a=='a2'){
						this.renderedMarkdown2 = '';
						this.form2.content = '';  
					}
				}else{
					this.$message({
						message:info.msg,
						 type: 'warning'
					})
				}
			},
			async fetchMarkdownInfo(id, targetProperty) {
			      try {  
			        const release = await this.$api.markdownGetInfo({ id:id});  
			        console.log('查询到的markdown详情', release);  
			        this[targetProperty] = release.data.title;  
			      } catch (error) {  
			        // console.error('获取 Markdown 信息失败', error);  
			      }  
			},  
			clog(e) {
				console.log(e);
			},
			verifyForm1(){
				if(this.form1.content == '' & this.form1.files == ''){
					this.$message({
						message: '请上传文件或模板',
						type: 'warning'
					})
					return
				}else{
					this.commitHand('form1')
				}
			},
			verifyForm3() {
			    // 检查内容、文件、人员消息类型和专家类型是否填写
			    if (this.form2.content == '' && this.form2.files == '' || 
			        this.form2.people_msg_type == '' || 
			        this.form2.specialist_type == '') {
			        this.$message({
			            message: '请填写完整信息',
			            type: 'warning'
			        });
			        return;
			    }
			
			    // 如果选择了上传个人简历，检查是否已上传文件
			    if (this.form2.people_msg_type == 3 && this.fileList2.length == 0) {
			        this.$message({
			            message: '请上传简历',
			            type: 'warning'
			        });
			        return;
			    }
			
			    // 如果所有检查都通过，则提交表单
			    this.commitHand('form2');
			},
			commitHand(form){
				this.formActionObj[form].commit(this[form]).then(res=>{
					console.log(res);
					if(res.code == 1){
						this.$message({
							message: res.msg,
							type: 'success'
						})
						setTimeout(()=>{
							location.reload()
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}
				})
			},
			
			async getTemplateLists() {
				const zy = await this.$api.templateLists({
					templatecate_id: 4
				})
				this.zyTemplate = zy.data
			},
			uploadWZB1(e, file) {
				this.formFiles1.push(file.response.data.url)
				this.form1.files = this.formFiles1.join(',')
			},
			uploadWZB2(e, file) {
				this.formFiles2.push(file.response.data.url)
				this.form2.files = this.formFiles2.join(',')
			},
			uploadWZB3(e, file) {
				this.formFiles3.push(file.response.data.url)
				this.form2.file = this.formFiles3.join(',')
			},
			toMbDetail(id, index) {
				this.$router.push(`/editor?id=${id}&index=${index}`)
			},
		}
	}
</script>
<style>
	.el-radio__inner {
		border-radius: 0;
	}

	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		/* 这里显示矩形的一半边框再旋转45度来实现对勾样式 */
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	}
</style>
<style scoped lang="less">
	.wenJuan {
		margin-left: 80px;
	}

	.item-content {
		display: flex;

		.muban {
			
			display: flex;
			justify-content: center;
			align-items: center;
			width: 148px;
			height: 148px;
			background: #F6F6F6;
			cursor: pointer;
			margin-left: 50px;
			&>div {
				display: flex;
				justify-content: center;
				flex-wrap: wrap;
			}

			p {
				width: 100%;
				text-align: center;
				margin-top: 10px;
			}
			&:first-child {
				margin-left: 0;
			}
		}

		.muban:hover {
			background: #e3e3e3;
		}
	}

	/deep/.el-radio {
		color: black;
		width: 200px;
	}

	.submit {
		width: 261px;
		height: 40px;
		background: #0052D9;
		text-align: center;
		margin: auto;
		margin-top: 40px;
		line-height: 40px;
		color: white;
		cursor: pointer;
		font-size: 18px;
	}

	.body {
		.card-four {
			width: 880px;
			display: flex;
			margin-top: 30px;
			margin-left: 60px;
			flex-wrap: wrap;

			.AIdingwei {
				margin-top: 20px;

				.AIbody {
					margin: 15px 0;
					margin-left: 50px;

					.Aianswer {
						margin: 20px 0;
						width: 1000px;
						height: 130px;
						background: #F6F6F6;
						border: 1px solid #E5E5E5;
						padding: 35px;
						box-sizing: border-box;

						p {
							height: 60px;
							font-family: PingFang;
							font-weight: 500;
							color: #888888;
							line-height: 30px;
							overflow: hidden;
							position: relative;

							&::after {
								position: absolute;
								bottom: 0;
								right: 10px;
								width: 1.2em;
							}
						}


					}
				}
			}
		}

		.card-three {
			width: 880px;
			display: flex;
			margin-top: 30px;
			margin-left: 60px;
			flex-wrap: wrap;

			.jieshao {
				margin-top: 20px;
			}

			.head-muban {
				width: 100%;

				.content {
					padding-top: 20px;
					padding-left: 70px;
					margin-bottom: 40px;
				}
			}

		}

		.card-two {
			width: 880px;
			margin-top: 30px;
			margin-left: 60px;
		}

		.card-one {
			width: 880px;
			display: flex;
			margin-top: 30px;
			margin-left: 60px;

			.content {
				padding-top: 30px;
				flex: 1;
				flex-wrap: wrap;
			}
		}

		.mktitle {
			.activeCard {
				background: #0052D9;
				color: white;
			}

			margin-top: 30px;
			margin-left: 35px;
			display: flex;
			width: 900px;

			&>div {
				cursor: pointer;
				line-height: 46px;
				text-align: center;
				margin-left: 25px;
				width: 262px;
				height: 46px;
				background: #F6F6F6;
				border: 1px solid #E5E5E5;
			}
		}

		padding: 20px 0;
		padding-top: 30px;
		background: white;
		padding-bottom: 50px;
	}
	.m1 {
	  /* 设置一个固定的宽度，或者根据布局需要调整 */
	  width: 200px; /* 示例宽度，你可以根据需要调整 */
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  /* 可选：添加一些内边距或外边距 */
	  padding: 10px;
	  box-sizing: border-box;
	}
	.m2 {
		/* 确保文本在达到容器宽度时自动换行 */
		word-wrap: break-word;
		overflow-wrap: break-word; /* 这是一个更现代的属性名，与word-wrap等效 */
		white-space: normal; /* 默认值，但明确设置可以避免潜在的CSS继承问题 */
		text-align: center; /* 可选：根据需要将文本居中 */
		/* 可选：添加一些上边距或下边距 */
		margin-top: 5px;
	}
</style>